import React from "react";

function Policy() {
  return (
    <div className="w-full h-full flex flex-col justify-start overflow-y-auto text-white px-4 pt-4 pb-5">
      <p className="font-raleway text-[14px] font-normal leading-relaxed">
        Настоящая Политика конфиденциальности приложения FitAbility (далее —
        Политика) действует в отношении всей информации, которую
        компания-разработчик может получить о пользователя во время работы с
        сервисом. Использование приложения означает безоговорочное согласие
        пользователя с настоящей Политикой и указанными в ней условиями
        обработки его персональной информации. В случае несогласия с этими
        условиями пользователь должен воздержаться от использования приложения.{" "}
        <br />
        <br />
        Персональная информация, которую получает и обрабатывает приложение
        «FitAbility».
        <br />
        <br />В рамках настоящей Политики под «персональной информацией
        пользователя» понимаются:
        <br />
        <br />
        Персональные данные, которые пользователь предоставляет о себе
        самостоятельно при регистрации (создании учётной записи) или в процессе
        использования приложения. Информация предоставляется пользователем на
        его усмотрение.
        <br />
        <br />
        Не персональная идентифицирующая информация, предоставляемая и
        серверами. Сюда относится тип операционной системы, языковые
        предпочтения, ссылающийся сайт, а также дата и время запроса посетителя.
        Целью сбора данной информации является анализ пользовательской
        активности и использования приложений.
        <br />
        <br />
        Потенциально лично-идентифицирующая информация, такая как
        интернет-протокол (IP) адреса. Такая информация может включать данные о
        местоположении конечных пользователей. Данные сведения не используются
        для идентификации посетителей и не раскрываются ни при каких
        обстоятельствах, кроме описанных в этой Политике конфиденциальности.
        <br />
        <br />
        Настоящая Политика применима только к приложению «FitAbility».
        Компания-разработчик не контролирует и не несет ответственность за
        информацию третьих лиц, на которые пользователь может перейти по
        ссылкам, доступным в приложении. На таких сайтах у пользователя может
        собираться или запрашиваться иная персональная информация, а также могут
        совершаться иные действия.
        <br />
        <br />
        Компания-разработчик в общем случае не проверяет достоверность
        персональной информации, предоставляемой пользователями, и не
        осуществляет контроль за их дееспособностью. Компания исходит из того,
        что информация, переданная им пользователем, является достоверной и
        поддерживает ее в актуальном состоянии.
        <br />
        <br />
        Посетитель имеет право отказаться от предоставления персональных данных,
        однако это может ограничить возможности использования ряда функций
        приложения.
        <br />
        <br />
        Если Вы предоставили свой адрес электронной почты, на него могут быть
        отправлены сообщения с информацией о новых товарах и услугах, функциях
        приложения или сайта, предложение оставить свой отзыв или обратную связь
        и т.п.
      </p>
    </div>
  );
}

export default Policy;
